<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/bad' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>不良售后反馈</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">订单编号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderId" size="small" @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <!-- <el-col :span="5" class="display-row">
            <div class="query-title">是否已处理:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.status" placeholder="请选择" size="small" clearable>
                <el-option key="" value="" label="全部"></el-option>
                <el-option key="0" value="0" label="未回复"></el-option>
                <el-option key="1" value="1" label="已回复"></el-option>
              </el-select>
            </div>
          </el-col> -->
          <!-- <el-col :span="4" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
            </div>
          </el-col> -->
        </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="18" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === ''}" @click="changeTab('')">全部
              </el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}" @click="changeTab(0)">未回复<span
                  class="lx-red">({{badCount.notReplyCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}" @click="changeTab(1)">已回复<span
                  class="lx-red"></span></el-button>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" v-loading="isLoading"
          :data="messageList" border height="550">
          <el-table-column type="index" label="序号" align="center" width="40"></el-table-column>
          <el-table-column prop="id" align="center" label="订单编号" width="70" v-if="false">
          </el-table-column>
          <el-table-column prop="orderId" align="center" label="订单编号" width="70">
          </el-table-column>
          <el-table-column prop="status" :index="indexMethod" sortable align="center" width="70" label="状态">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60">
            <template v-slot="scope">
              <div v-if="scope.row.status=='0'">
                <div class="btn-row">
                  <el-button class="list-btn btn-green" @click="reply(scope.row)">
                    回复
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="notes" label="工作签" align="left" width="200">
            <template v-slot="scope">
              <el-input v-model="scope.row.notes" type="textarea" size="small" @change="updateNotes(scope.row)"
                placeholder="请输入内容" />
            </template>
          </el-table-column>
          <el-table-column prop="customerRealName" label="客户名">
          </el-table-column>
          <el-table-column prop="customerName" label="客户ID">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="150" sortable align="center" :index="indexMethod"
            :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="badPicture1" label="不良图片" width="110">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture1,true)" v-if="scope.row.badPicture1&&scope.row.badPicture1.length>0"
                :src="scope.row.badPicture1" alt="" class="list-image" style="width: 100px;height: 100px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 100px;height: 100px;">
              <!--<img :src="scope.row.badPicture1" alt="" style="width: 100px;height: 100px;">-->
            </template>
          </el-table-column>
          <el-table-column prop="badPicture2" label="不良图片" width="110">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture2,true)" v-if="scope.row.badPicture2&&scope.row.badPicture2.length>0"
                :src="scope.row.badPicture2" alt="" class="list-image" style="width: 100px;height: 100px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 100px;height: 100px;">
              <!--<img :src="scope.row.badPicture2" alt="" style="width: 100px;height: 100px;">-->
            </template>
          </el-table-column>
          <el-table-column prop="badPicture3" label="不良图片" width="110">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture3,true)" v-if="scope.row.badPicture3&&scope.row.badPicture3.length>0"
                :src="scope.row.badPicture3" alt="" class="list-image" style="width: 100px;height: 100px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 100px;height: 100px;">
              <!--<img :src="scope.row.badPicture3" alt="" style="width: 100px;height: 100px;">-->
            </template>
          </el-table-column>
          <el-table-column prop="badPicture4" label="不良图片" width="110">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture4,true)" v-if="scope.row.badPicture4&&scope.row.badPicture4.length>0"
                :src="scope.row.badPicture4" alt="" class="list-image" style="width: 100px;height: 100px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 100px;height: 100px;">
              <!--<img :src="scope.row.badPicture3" alt="" style="width: 100px;height: 100px;">-->
            </template>
          </el-table-column>
          <el-table-column prop="replyTime" label="回复时间" width="150" sortable align="center" :index="indexMethod"
            :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="replyRemark" label="回复内容">
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 回复 -->
    <el-dialog title="回复" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfos" :rules="rules" ref="replyInfoRef" label-width="120px" class="demo-replyInfo">
        <div style="display: none">
          <el-form-item label="id：" prop="id">
            <el-input v-model="replyInfos.id" size="small" style="width: 90%" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="订单编号：" prop="orderId">
          <el-input v-model="replyInfos.orderId" size="small" style="width: 90%" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="回复内容" prop="replyRemark">
          <el-input type="textarea" v-model="replyInfos.replyRemark" size="small" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="clearReplyForm">取 消</el-button>

        <el-button class="form-btn btn-blue" @click="replySave">提 交</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'bad',
  data () {
    return {
      isActive:false,
      curIndex: '',
      isLoading: false,
      visible: false,
      imgurl: '',
      replyInfos: {
        id: '',
        orderId: '',
        replyRemark: '',
      },
      rules: {
        orderId: [
          { required: true, message: 'No不能为空', trigger: 'blur' }
        ],
        replyRemark: [
          { required: true, message: '回复内容不能为空', trigger: 'blur' }
        ]
      },
      queryInfo: {
        orderId: '',
        status: '',
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1
      },
      badCount: {
        total: 0,
        replyCount: 0,
        notReplyCount: 0
      },
      badDateRangeValue: [],
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      messageInfo: {
        id: '',
        remindingContent: '',
        remindingTitle: '',
        remindingPicture: ''
      },    //回复新的内容
      messageTypeOptions: [
        {
          value: '1',
          label: '订单消息'
        }, {
          value: '2',
          label: '其他消息'
        }
      ],
      replyStatusOptions: [
        {
          value: '0',
          label: '未回复'
        }, {
          value: '1',
          label: '已回复'
        }
      ],
      messageList: [],
      dialogFormVisible: false,
      replyDialogVisible: false,
      total: 0,
    }
  },
  methods: {
    changeTab (index) {
      this.curIndex = index
      this.searchList()
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    handleSizeChange (newSize) {   //分页
      this.queryInfo.pageSize = newSize;
      this.getBadCount();
      this.getMessageList();
    },
    handleCurrentChange (newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getBadCount();
      this.getMessageList();
    },
    replySave () {    //保存回复内容按钮
      this.addReply(this.queryInfo.id);
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    clearReplyForm () {   //回复弹窗的取消按钮
      this.replyInfos.replyRemark = "";
      this.replyDialogVisible = false;
    },
    async addReply (id) {    //添加回复
      var my = this;
      this.$refs.replyInfoRef.validate(async function (valid) {
        if (valid) {
          var url = 'bad/reply';
          const { data: res } = await my.$http.post(url, my.replyInfos);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
              my.replyDialogVisible = false;
            my.getBadCount();
            my.getMessageList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    searchList () {    //查询
      this.queryInfo.status = this.curIndex
      this.queryInfo.pageNum = 1;
      this.getBadCount();
      this.getMessageList();
    },
    async getBadCount () {   //获取信息数量
      const { data: res } = await this.$http.get('bad/badCount', { params: this.queryInfo });
      this.badCount = res.data;
    },
    async getMessageList () {   //获取信息列表
      this.isLoading = true
      const { data: res } = await this.$http.get('bad/list', { params: this.queryInfo });
      this.isLoading = false
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.curIndex = '',
        this.queryInfo.createTimeStart = '',
        this.queryInfo.createTimeEnd = '',
        this.queryInfo.status = '',
        this.queryInfo.orderId = '',
        this.queryInfo.pageSize = 5,
        this.queryInfo.pageNum = 1
      this.badDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '0':
          return '未回复'
          break;
        case '1':
          return '已回复'
          break;
      }
    },
    reply (row) {     //回复
      this.replyDialogVisible = true;
      this.replyInfos.orderId = row.orderId;
      this.replyInfos.id = row.id;
    },
    async updateNotes (row) {
      var my = this;
      var url = 'bad/updateNote';
      const { data: res } = await my.$http.post(url, row);
      if (res.code == 200) {
        my.$message({
          type: 'success',
          message: res.message
        }),
          my.replyDialogVisible = false;
        my.getBadCount();
        // my.getMessageList();
      } else {
        my.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    replyDialogClose () {    //关闭回复弹窗
      this.replyDialogVisible = false;
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    badDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.badDateRangeValue) {
        this.badDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.badDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.badDateRangeValue[0] + " 00:00:00";
          this.queryInfo.createTimeEnd = this.badDateRangeValue[1] + " 23:59:59";
        }
      }

    }
  },
  created () {
    this.getBadCount();
    this.getMessageList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.search-btn-container-status {
  text-align: left !important;
}
</style>
